import { SongListEntryType, SongListSchema } from '../../../../../common/src/model.ts';

export function setSongListSchemaLabel(
  schema: SongListSchema | undefined,
  rowIndex: number,
  label?: string,
): SongListSchema {
  const { label: _unused, ...rowNoLabel } = schema?.rows.find(({ row }) => row === rowIndex) ?? {};
  return {
    ...schema,
    rows: [
      ...(schema?.rows.filter(({ row }) => row !== rowIndex) ?? []),
      {
        row: rowIndex,
        type: SongListEntryType.Song, // default
        ...rowNoLabel,
        ...(label && label !== '' && { label: label }),
      },
    ],
  };
}

export function setSongListSchemaType(
  schema: SongListSchema | undefined,
  rowIndex: number,
  type: SongListEntryType,
): SongListSchema {
  return {
    ...schema,
    rows: [
      ...(schema?.rows.filter(({ row }) => row !== rowIndex) ?? []),
      {
        row: rowIndex,
        ...schema?.rows.find(({ row }) => row === rowIndex),
        type,
      },
    ],
  };
}

export function setSongListSchemaRowAssigned(
  schema: SongListSchema | undefined,
  rowIndex: number,
  assigned: boolean,
): SongListSchema {
  return {
    ...schema,
    rows: [
      ...(schema?.rows.filter(({ row }) => row !== rowIndex) ?? []),
      {
        row: rowIndex,
        ...schema?.rows.find(({ row }) => row === rowIndex),
        type: SongListEntryType.Song,
        assigned,
      },
    ],
  };
}
